const KITCHEN_ITEMS = [
  // ── Fruits ──────────────────────────────────────────
  { name: 'Apple', category: 'Fruits', unit: 'grams', shelfDays: 21 },
  { name: 'Apricot', category: 'Fruits', unit: 'grams', shelfDays: 5 },
  { name: 'Avocado', category: 'Fruits', unit: 'grams', shelfDays: 5 },
  { name: 'Banana', category: 'Fruits', unit: 'grams', shelfDays: 7 },
  { name: 'Blackberry', category: 'Fruits', unit: 'grams', shelfDays: 3 },
  { name: 'Blueberry', category: 'Fruits', unit: 'grams', shelfDays: 7 },
  { name: 'Cantaloupe', category: 'Fruits', unit: 'grams', shelfDays: 7 },
  { name: 'Cherry', category: 'Fruits', unit: 'grams', shelfDays: 7 },
  { name: 'Clementine', category: 'Fruits', unit: 'grams', shelfDays: 14 },
  { name: 'Coconut', category: 'Fruits', unit: 'grams', shelfDays: 30 },
  { name: 'Cranberry', category: 'Fruits', unit: 'grams', shelfDays: 14 },
  { name: 'Date', category: 'Fruits', unit: 'grams', shelfDays: 60 },
  { name: 'Dragon Fruit', category: 'Fruits', unit: 'grams', shelfDays: 5 },
  { name: 'Fig', category: 'Fruits', unit: 'grams', shelfDays: 5 },
  { name: 'Grape', category: 'Fruits', unit: 'grams', shelfDays: 7 },
  { name: 'Grapefruit', category: 'Fruits', unit: 'grams', shelfDays: 21 },
  { name: 'Guava', category: 'Fruits', unit: 'grams', shelfDays: 5 },
  { name: 'Honeydew', category: 'Fruits', unit: 'grams', shelfDays: 7 },
  { name: 'Kiwi', category: 'Fruits', unit: 'grams', shelfDays: 14 },
  { name: 'Lemon', category: 'Fruits', unit: 'grams', shelfDays: 21 },
  { name: 'Lime', category: 'Fruits', unit: 'grams', shelfDays: 21 },
  { name: 'Lychee', category: 'Fruits', unit: 'grams', shelfDays: 5 },
  { name: 'Mango', category: 'Fruits', unit: 'grams', shelfDays: 7 },
  { name: 'Nectarine', category: 'Fruits', unit: 'grams', shelfDays: 5 },
  { name: 'Orange', category: 'Fruits', unit: 'grams', shelfDays: 21 },
  { name: 'Papaya', category: 'Fruits', unit: 'grams', shelfDays: 5 },
  { name: 'Passion Fruit', category: 'Fruits', unit: 'grams', shelfDays: 7 },
  { name: 'Peach', category: 'Fruits', unit: 'grams', shelfDays: 5 },
  { name: 'Pear', category: 'Fruits', unit: 'grams', shelfDays: 10 },
  { name: 'Pineapple', category: 'Fruits', unit: 'grams', shelfDays: 5 },
  { name: 'Plantain', category: 'Fruits', unit: 'grams', shelfDays: 7 },
  { name: 'Plum', category: 'Fruits', unit: 'grams', shelfDays: 5 },
  { name: 'Pomegranate', category: 'Fruits', unit: 'grams', shelfDays: 30 },
  { name: 'Raspberry', category: 'Fruits', unit: 'grams', shelfDays: 3 },
  { name: 'Starfruit', category: 'Fruits', unit: 'grams', shelfDays: 5 },
  { name: 'Strawberry', category: 'Fruits', unit: 'grams', shelfDays: 5 },
  { name: 'Tangerine', category: 'Fruits', unit: 'grams', shelfDays: 14 },
  { name: 'Watermelon', category: 'Fruits', unit: 'grams', shelfDays: 7 },

  // ── Vegetables ──────────────────────────────────────
  { name: 'Artichoke', category: 'Vegetables', unit: 'grams', shelfDays: 7 },
  { name: 'Arugula', category: 'Vegetables', unit: 'grams', shelfDays: 5 },
  { name: 'Asparagus', category: 'Vegetables', unit: 'grams', shelfDays: 5 },
  { name: 'Bean Sprouts', category: 'Vegetables', unit: 'grams', shelfDays: 3 },
  { name: 'Beet', category: 'Vegetables', unit: 'grams', shelfDays: 14 },
  { name: 'Bell Pepper', category: 'Vegetables', unit: 'grams', shelfDays: 7 },
  { name: 'Bok Choy', category: 'Vegetables', unit: 'grams', shelfDays: 5 },
  { name: 'Broccoli', category: 'Vegetables', unit: 'grams', shelfDays: 7 },
  { name: 'Brussels Sprouts', category: 'Vegetables', unit: 'grams', shelfDays: 7 },
  { name: 'Butternut Squash', category: 'Vegetables', unit: 'grams', shelfDays: 30 },
  { name: 'Cabbage', category: 'Vegetables', unit: 'grams', shelfDays: 14 },
  { name: 'Carrot', category: 'Vegetables', unit: 'grams', shelfDays: 21 },
  { name: 'Cauliflower', category: 'Vegetables', unit: 'grams', shelfDays: 7 },
  { name: 'Celery', category: 'Vegetables', unit: 'grams', shelfDays: 14 },
  { name: 'Collard Greens', category: 'Vegetables', unit: 'grams', shelfDays: 5 },
  { name: 'Corn', category: 'Vegetables', unit: 'grams', shelfDays: 5 },
  { name: 'Cucumber', category: 'Vegetables', unit: 'grams', shelfDays: 7 },
  { name: 'Daikon', category: 'Vegetables', unit: 'grams', shelfDays: 14 },
  { name: 'Eggplant', category: 'Vegetables', unit: 'grams', shelfDays: 7 },
  { name: 'Endive', category: 'Vegetables', unit: 'grams', shelfDays: 5 },
  { name: 'Fennel', category: 'Vegetables', unit: 'grams', shelfDays: 7 },
  { name: 'Green Beans', category: 'Vegetables', unit: 'grams', shelfDays: 7 },
  { name: 'Jalapeño', category: 'Vegetables', unit: 'grams', shelfDays: 14 },
  { name: 'Kale', category: 'Vegetables', unit: 'grams', shelfDays: 5 },
  { name: 'Kohlrabi', category: 'Vegetables', unit: 'grams', shelfDays: 14 },
  { name: 'Leek', category: 'Vegetables', unit: 'grams', shelfDays: 10 },
  { name: 'Lettuce', category: 'Vegetables', unit: 'grams', shelfDays: 5 },
  { name: 'Mushroom', category: 'Vegetables', unit: 'grams', shelfDays: 5 },
  { name: 'Okra', category: 'Vegetables', unit: 'grams', shelfDays: 5 },
  { name: 'Onion', category: 'Vegetables', unit: 'grams', shelfDays: 30 },
  { name: 'Parsnip', category: 'Vegetables', unit: 'grams', shelfDays: 21 },
  { name: 'Peas', category: 'Vegetables', unit: 'grams', shelfDays: 5 },
  { name: 'Potato', category: 'Vegetables', unit: 'grams', shelfDays: 30 },
  { name: 'Pumpkin', category: 'Vegetables', unit: 'grams', shelfDays: 30 },
  { name: 'Radicchio', category: 'Vegetables', unit: 'grams', shelfDays: 7 },
  { name: 'Radish', category: 'Vegetables', unit: 'grams', shelfDays: 14 },
  { name: 'Romaine Lettuce', category: 'Vegetables', unit: 'grams', shelfDays: 7 },
  { name: 'Rutabaga', category: 'Vegetables', unit: 'grams', shelfDays: 21 },
  { name: 'Scallion', category: 'Vegetables', unit: 'grams', shelfDays: 7 },
  { name: 'Shallot', category: 'Vegetables', unit: 'grams', shelfDays: 30 },
  { name: 'Snow Peas', category: 'Vegetables', unit: 'grams', shelfDays: 5 },
  { name: 'Spinach', category: 'Vegetables', unit: 'grams', shelfDays: 5 },
  { name: 'Sugar Snap Peas', category: 'Vegetables', unit: 'grams', shelfDays: 5 },
  { name: 'Sweet Potato', category: 'Vegetables', unit: 'grams', shelfDays: 21 },
  { name: 'Swiss Chard', category: 'Vegetables', unit: 'grams', shelfDays: 5 },
  { name: 'Tomatillo', category: 'Vegetables', unit: 'grams', shelfDays: 14 },
  { name: 'Tomato', category: 'Vegetables', unit: 'grams', shelfDays: 7 },
  { name: 'Turnip', category: 'Vegetables', unit: 'grams', shelfDays: 21 },
  { name: 'Watercress', category: 'Vegetables', unit: 'grams', shelfDays: 3 },
  { name: 'Yam', category: 'Vegetables', unit: 'grams', shelfDays: 21 },
  { name: 'Zucchini', category: 'Vegetables', unit: 'grams', shelfDays: 7 },

  // ── Herbs & Aromatics ──────────────────────────────
  { name: 'Basil', category: 'Herbs', unit: 'grams', shelfDays: 5 },
  { name: 'Bay Leaves', category: 'Herbs', unit: 'grams', shelfDays: 365 },
  { name: 'Chives', category: 'Herbs', unit: 'grams', shelfDays: 7 },
  { name: 'Cilantro', category: 'Herbs', unit: 'grams', shelfDays: 7 },
  { name: 'Dill', category: 'Herbs', unit: 'grams', shelfDays: 7 },
  { name: 'Garlic', category: 'Herbs', unit: 'grams', shelfDays: 30 },
  { name: 'Ginger', category: 'Herbs', unit: 'grams', shelfDays: 21 },
  { name: 'Lemongrass', category: 'Herbs', unit: 'grams', shelfDays: 14 },
  { name: 'Mint', category: 'Herbs', unit: 'grams', shelfDays: 7 },
  { name: 'Oregano (fresh)', category: 'Herbs', unit: 'grams', shelfDays: 7 },
  { name: 'Parsley', category: 'Herbs', unit: 'grams', shelfDays: 7 },
  { name: 'Rosemary', category: 'Herbs', unit: 'grams', shelfDays: 14 },
  { name: 'Sage', category: 'Herbs', unit: 'grams', shelfDays: 7 },
  { name: 'Tarragon', category: 'Herbs', unit: 'grams', shelfDays: 7 },
  { name: 'Thyme', category: 'Herbs', unit: 'grams', shelfDays: 14 },
  { name: 'Turmeric Root', category: 'Herbs', unit: 'grams', shelfDays: 21 },

  // ── Meat & Poultry ─────────────────────────────────
  { name: 'Chicken Breast', category: 'Meat', unit: 'grams', shelfDays: 3 },
  { name: 'Chicken Thigh', category: 'Meat', unit: 'grams', shelfDays: 3 },
  { name: 'Chicken Drumstick', category: 'Meat', unit: 'grams', shelfDays: 3 },
  { name: 'Chicken Wings', category: 'Meat', unit: 'grams', shelfDays: 3 },
  { name: 'Whole Chicken', category: 'Meat', unit: 'grams', shelfDays: 3 },
  { name: 'Ground Chicken', category: 'Meat', unit: 'grams', shelfDays: 2 },
  { name: 'Ground Turkey', category: 'Meat', unit: 'grams', shelfDays: 2 },
  { name: 'Turkey Breast', category: 'Meat', unit: 'grams', shelfDays: 3 },
  { name: 'Duck Breast', category: 'Meat', unit: 'grams', shelfDays: 3 },
  { name: 'Ground Beef', category: 'Meat', unit: 'grams', shelfDays: 2 },
  { name: 'Beef Steak (Ribeye)', category: 'Meat', unit: 'grams', shelfDays: 5 },
  { name: 'Beef Steak (Sirloin)', category: 'Meat', unit: 'grams', shelfDays: 5 },
  { name: 'Beef Steak (Filet Mignon)', category: 'Meat', unit: 'grams', shelfDays: 5 },
  { name: 'Beef Chuck Roast', category: 'Meat', unit: 'grams', shelfDays: 5 },
  { name: 'Beef Brisket', category: 'Meat', unit: 'grams', shelfDays: 5 },
  { name: 'Beef Short Ribs', category: 'Meat', unit: 'grams', shelfDays: 5 },
  { name: 'Beef Stew Meat', category: 'Meat', unit: 'grams', shelfDays: 3 },
  { name: 'Flank Steak', category: 'Meat', unit: 'grams', shelfDays: 5 },
  { name: 'Skirt Steak', category: 'Meat', unit: 'grams', shelfDays: 5 },
  { name: 'Pork Chop', category: 'Meat', unit: 'grams', shelfDays: 5 },
  { name: 'Pork Tenderloin', category: 'Meat', unit: 'grams', shelfDays: 5 },
  { name: 'Pork Shoulder', category: 'Meat', unit: 'grams', shelfDays: 5 },
  { name: 'Pork Belly', category: 'Meat', unit: 'grams', shelfDays: 5 },
  { name: 'Ground Pork', category: 'Meat', unit: 'grams', shelfDays: 2 },
  { name: 'Bacon', category: 'Meat', unit: 'grams', shelfDays: 7 },
  { name: 'Ham', category: 'Meat', unit: 'grams', shelfDays: 7 },
  { name: 'Prosciutto', category: 'Meat', unit: 'grams', shelfDays: 7 },
  { name: 'Pancetta', category: 'Meat', unit: 'grams', shelfDays: 7 },
  { name: 'Italian Sausage', category: 'Meat', unit: 'grams', shelfDays: 3 },
  { name: 'Chorizo', category: 'Meat', unit: 'grams', shelfDays: 7 },
  { name: 'Bratwurst', category: 'Meat', unit: 'grams', shelfDays: 3 },
  { name: 'Lamb Chop', category: 'Meat', unit: 'grams', shelfDays: 5 },
  { name: 'Lamb Leg', category: 'Meat', unit: 'grams', shelfDays: 5 },
  { name: 'Ground Lamb', category: 'Meat', unit: 'grams', shelfDays: 2 },
  { name: 'Venison', category: 'Meat', unit: 'grams', shelfDays: 5 },
  { name: 'Bison', category: 'Meat', unit: 'grams', shelfDays: 5 },

  // ── Seafood ─────────────────────────────────────────
  { name: 'Salmon Fillet', category: 'Seafood', unit: 'grams', shelfDays: 2 },
  { name: 'Tuna Steak', category: 'Seafood', unit: 'grams', shelfDays: 2 },
  { name: 'Cod Fillet', category: 'Seafood', unit: 'grams', shelfDays: 2 },
  { name: 'Halibut', category: 'Seafood', unit: 'grams', shelfDays: 2 },
  { name: 'Tilapia', category: 'Seafood', unit: 'grams', shelfDays: 2 },
  { name: 'Sea Bass', category: 'Seafood', unit: 'grams', shelfDays: 2 },
  { name: 'Mahi-Mahi', category: 'Seafood', unit: 'grams', shelfDays: 2 },
  { name: 'Swordfish', category: 'Seafood', unit: 'grams', shelfDays: 2 },
  { name: 'Trout', category: 'Seafood', unit: 'grams', shelfDays: 2 },
  { name: 'Sardines', category: 'Seafood', unit: 'grams', shelfDays: 2 },
  { name: 'Anchovies', category: 'Seafood', unit: 'grams', shelfDays: 60 },
  { name: 'Shrimp', category: 'Seafood', unit: 'grams', shelfDays: 2 },
  { name: 'Crab Meat', category: 'Seafood', unit: 'grams', shelfDays: 2 },
  { name: 'Lobster Tail', category: 'Seafood', unit: 'grams', shelfDays: 2 },
  { name: 'Scallops', category: 'Seafood', unit: 'grams', shelfDays: 2 },
  { name: 'Mussels', category: 'Seafood', unit: 'grams', shelfDays: 2 },
  { name: 'Clams', category: 'Seafood', unit: 'grams', shelfDays: 2 },
  { name: 'Oysters', category: 'Seafood', unit: 'grams', shelfDays: 2 },
  { name: 'Calamari', category: 'Seafood', unit: 'grams', shelfDays: 2 },
  { name: 'Canned Tuna', category: 'Seafood', unit: 'grams', shelfDays: 730 },
  { name: 'Canned Salmon', category: 'Seafood', unit: 'grams', shelfDays: 730 },

  // ── Dairy & Eggs ────────────────────────────────────
  { name: 'Whole Milk', category: 'Dairy', unit: 'ml', shelfDays: 7 },
  { name: '2% Milk', category: 'Dairy', unit: 'ml', shelfDays: 7 },
  { name: 'Skim Milk', category: 'Dairy', unit: 'ml', shelfDays: 7 },
  { name: 'Heavy Cream', category: 'Dairy', unit: 'ml', shelfDays: 10 },
  { name: 'Half and Half', category: 'Dairy', unit: 'ml', shelfDays: 7 },
  { name: 'Buttermilk', category: 'Dairy', unit: 'ml', shelfDays: 14 },
  { name: 'Butter', category: 'Dairy', unit: 'grams', shelfDays: 30 },
  { name: 'Ghee', category: 'Dairy', unit: 'grams', shelfDays: 90 },
  { name: 'Cream Cheese', category: 'Dairy', unit: 'grams', shelfDays: 14 },
  { name: 'Sour Cream', category: 'Dairy', unit: 'grams', shelfDays: 14 },
  { name: 'Greek Yogurt', category: 'Dairy', unit: 'grams', shelfDays: 14 },
  { name: 'Plain Yogurt', category: 'Dairy', unit: 'grams', shelfDays: 14 },
  { name: 'Cottage Cheese', category: 'Dairy', unit: 'grams', shelfDays: 7 },
  { name: 'Ricotta', category: 'Dairy', unit: 'grams', shelfDays: 7 },
  { name: 'Mascarpone', category: 'Dairy', unit: 'grams', shelfDays: 7 },
  { name: 'Mozzarella', category: 'Dairy', unit: 'grams', shelfDays: 14 },
  { name: 'Cheddar Cheese', category: 'Dairy', unit: 'grams', shelfDays: 30 },
  { name: 'Parmesan', category: 'Dairy', unit: 'grams', shelfDays: 60 },
  { name: 'Gruyère', category: 'Dairy', unit: 'grams', shelfDays: 30 },
  { name: 'Swiss Cheese', category: 'Dairy', unit: 'grams', shelfDays: 30 },
  { name: 'Gouda', category: 'Dairy', unit: 'grams', shelfDays: 30 },
  { name: 'Brie', category: 'Dairy', unit: 'grams', shelfDays: 14 },
  { name: 'Feta', category: 'Dairy', unit: 'grams', shelfDays: 21 },
  { name: 'Goat Cheese', category: 'Dairy', unit: 'grams', shelfDays: 14 },
  { name: 'Blue Cheese', category: 'Dairy', unit: 'grams', shelfDays: 21 },
  { name: 'Provolone', category: 'Dairy', unit: 'grams', shelfDays: 21 },
  { name: 'Monterey Jack', category: 'Dairy', unit: 'grams', shelfDays: 21 },
  { name: 'Pepper Jack', category: 'Dairy', unit: 'grams', shelfDays: 21 },
  { name: 'American Cheese', category: 'Dairy', unit: 'grams', shelfDays: 21 },
  { name: 'Eggs', category: 'Dairy', unit: 'grams', shelfDays: 28 },
  { name: 'Egg Whites', category: 'Dairy', unit: 'ml', shelfDays: 5 },

  // ── Grains & Pasta ──────────────────────────────────
  { name: 'White Rice', category: 'Grains', unit: 'grams', shelfDays: 730 },
  { name: 'Brown Rice', category: 'Grains', unit: 'grams', shelfDays: 180 },
  { name: 'Jasmine Rice', category: 'Grains', unit: 'grams', shelfDays: 730 },
  { name: 'Basmati Rice', category: 'Grains', unit: 'grams', shelfDays: 730 },
  { name: 'Arborio Rice', category: 'Grains', unit: 'grams', shelfDays: 730 },
  { name: 'Wild Rice', category: 'Grains', unit: 'grams', shelfDays: 365 },
  { name: 'Quinoa', category: 'Grains', unit: 'grams', shelfDays: 365 },
  { name: 'Couscous', category: 'Grains', unit: 'grams', shelfDays: 365 },
  { name: 'Bulgur', category: 'Grains', unit: 'grams', shelfDays: 365 },
  { name: 'Farro', category: 'Grains', unit: 'grams', shelfDays: 365 },
  { name: 'Barley', category: 'Grains', unit: 'grams', shelfDays: 365 },
  { name: 'Millet', category: 'Grains', unit: 'grams', shelfDays: 365 },
  { name: 'Polenta', category: 'Grains', unit: 'grams', shelfDays: 365 },
  { name: 'Rolled Oats', category: 'Grains', unit: 'grams', shelfDays: 365 },
  { name: 'Steel Cut Oats', category: 'Grains', unit: 'grams', shelfDays: 365 },
  { name: 'Spaghetti', category: 'Grains', unit: 'grams', shelfDays: 730 },
  { name: 'Penne', category: 'Grains', unit: 'grams', shelfDays: 730 },
  { name: 'Fusilli', category: 'Grains', unit: 'grams', shelfDays: 730 },
  { name: 'Rigatoni', category: 'Grains', unit: 'grams', shelfDays: 730 },
  { name: 'Linguine', category: 'Grains', unit: 'grams', shelfDays: 730 },
  { name: 'Fettuccine', category: 'Grains', unit: 'grams', shelfDays: 730 },
  { name: 'Orzo', category: 'Grains', unit: 'grams', shelfDays: 730 },
  { name: 'Lasagna Noodles', category: 'Grains', unit: 'grams', shelfDays: 730 },
  { name: 'Egg Noodles', category: 'Grains', unit: 'grams', shelfDays: 365 },
  { name: 'Rice Noodles', category: 'Grains', unit: 'grams', shelfDays: 730 },
  { name: 'Soba Noodles', category: 'Grains', unit: 'grams', shelfDays: 365 },
  { name: 'Udon Noodles', category: 'Grains', unit: 'grams', shelfDays: 365 },
  { name: 'Ramen Noodles', category: 'Grains', unit: 'grams', shelfDays: 365 },

  // ── Bread & Bakery ──────────────────────────────────
  { name: 'White Bread', category: 'Bakery', unit: 'grams', shelfDays: 5 },
  { name: 'Whole Wheat Bread', category: 'Bakery', unit: 'grams', shelfDays: 5 },
  { name: 'Sourdough Bread', category: 'Bakery', unit: 'grams', shelfDays: 5 },
  { name: 'Ciabatta', category: 'Bakery', unit: 'grams', shelfDays: 3 },
  { name: 'Baguette', category: 'Bakery', unit: 'grams', shelfDays: 2 },
  { name: 'Pita Bread', category: 'Bakery', unit: 'grams', shelfDays: 5 },
  { name: 'Naan', category: 'Bakery', unit: 'grams', shelfDays: 5 },
  { name: 'Tortillas (flour)', category: 'Bakery', unit: 'grams', shelfDays: 14 },
  { name: 'Tortillas (corn)', category: 'Bakery', unit: 'grams', shelfDays: 14 },
  { name: 'English Muffins', category: 'Bakery', unit: 'grams', shelfDays: 7 },
  { name: 'Bagels', category: 'Bakery', unit: 'grams', shelfDays: 5 },
  { name: 'Croissants', category: 'Bakery', unit: 'grams', shelfDays: 3 },
  { name: 'Breadcrumbs', category: 'Bakery', unit: 'grams', shelfDays: 180 },
  { name: 'Panko', category: 'Bakery', unit: 'grams', shelfDays: 180 },
  { name: 'Croutons', category: 'Bakery', unit: 'grams', shelfDays: 60 },

  // ── Legumes & Beans ─────────────────────────────────
  { name: 'Black Beans (canned)', category: 'Legumes', unit: 'grams', shelfDays: 730 },
  { name: 'Black Beans (dried)', category: 'Legumes', unit: 'grams', shelfDays: 730 },
  { name: 'Kidney Beans', category: 'Legumes', unit: 'grams', shelfDays: 730 },
  { name: 'Cannellini Beans', category: 'Legumes', unit: 'grams', shelfDays: 730 },
  { name: 'Navy Beans', category: 'Legumes', unit: 'grams', shelfDays: 730 },
  { name: 'Pinto Beans', category: 'Legumes', unit: 'grams', shelfDays: 730 },
  { name: 'Chickpeas', category: 'Legumes', unit: 'grams', shelfDays: 730 },
  { name: 'Lentils (green)', category: 'Legumes', unit: 'grams', shelfDays: 365 },
  { name: 'Lentils (red)', category: 'Legumes', unit: 'grams', shelfDays: 365 },
  { name: 'Lentils (brown)', category: 'Legumes', unit: 'grams', shelfDays: 365 },
  { name: 'Split Peas', category: 'Legumes', unit: 'grams', shelfDays: 365 },
  { name: 'Edamame', category: 'Legumes', unit: 'grams', shelfDays: 5 },
  { name: 'Tofu', category: 'Legumes', unit: 'grams', shelfDays: 7 },
  { name: 'Tempeh', category: 'Legumes', unit: 'grams', shelfDays: 10 },

  // ── Nuts & Seeds ────────────────────────────────────
  { name: 'Almonds', category: 'Nuts & Seeds', unit: 'grams', shelfDays: 180 },
  { name: 'Cashews', category: 'Nuts & Seeds', unit: 'grams', shelfDays: 180 },
  { name: 'Walnuts', category: 'Nuts & Seeds', unit: 'grams', shelfDays: 180 },
  { name: 'Pecans', category: 'Nuts & Seeds', unit: 'grams', shelfDays: 180 },
  { name: 'Peanuts', category: 'Nuts & Seeds', unit: 'grams', shelfDays: 180 },
  { name: 'Pistachios', category: 'Nuts & Seeds', unit: 'grams', shelfDays: 180 },
  { name: 'Macadamia Nuts', category: 'Nuts & Seeds', unit: 'grams', shelfDays: 180 },
  { name: 'Hazelnuts', category: 'Nuts & Seeds', unit: 'grams', shelfDays: 180 },
  { name: 'Pine Nuts', category: 'Nuts & Seeds', unit: 'grams', shelfDays: 90 },
  { name: 'Brazil Nuts', category: 'Nuts & Seeds', unit: 'grams', shelfDays: 180 },
  { name: 'Sunflower Seeds', category: 'Nuts & Seeds', unit: 'grams', shelfDays: 180 },
  { name: 'Pumpkin Seeds', category: 'Nuts & Seeds', unit: 'grams', shelfDays: 180 },
  { name: 'Chia Seeds', category: 'Nuts & Seeds', unit: 'grams', shelfDays: 365 },
  { name: 'Flax Seeds', category: 'Nuts & Seeds', unit: 'grams', shelfDays: 365 },
  { name: 'Hemp Seeds', category: 'Nuts & Seeds', unit: 'grams', shelfDays: 365 },
  { name: 'Sesame Seeds', category: 'Nuts & Seeds', unit: 'grams', shelfDays: 365 },
  { name: 'Poppy Seeds', category: 'Nuts & Seeds', unit: 'grams', shelfDays: 365 },

  // ── Oils & Vinegars ─────────────────────────────────
  { name: 'Olive Oil', category: 'Oils', unit: 'ml', shelfDays: 365 },
  { name: 'Extra Virgin Olive Oil', category: 'Oils', unit: 'ml', shelfDays: 365 },
  { name: 'Vegetable Oil', category: 'Oils', unit: 'ml', shelfDays: 365 },
  { name: 'Canola Oil', category: 'Oils', unit: 'ml', shelfDays: 365 },
  { name: 'Coconut Oil', category: 'Oils', unit: 'ml', shelfDays: 365 },
  { name: 'Sesame Oil', category: 'Oils', unit: 'ml', shelfDays: 180 },
  { name: 'Avocado Oil', category: 'Oils', unit: 'ml', shelfDays: 365 },
  { name: 'Grapeseed Oil', category: 'Oils', unit: 'ml', shelfDays: 180 },
  { name: 'Truffle Oil', category: 'Oils', unit: 'ml', shelfDays: 180 },
  { name: 'Peanut Oil', category: 'Oils', unit: 'ml', shelfDays: 365 },
  { name: 'Balsamic Vinegar', category: 'Oils', unit: 'ml', shelfDays: 730 },
  { name: 'Red Wine Vinegar', category: 'Oils', unit: 'ml', shelfDays: 730 },
  { name: 'White Wine Vinegar', category: 'Oils', unit: 'ml', shelfDays: 730 },
  { name: 'Apple Cider Vinegar', category: 'Oils', unit: 'ml', shelfDays: 730 },
  { name: 'Rice Vinegar', category: 'Oils', unit: 'ml', shelfDays: 730 },
  { name: 'Distilled White Vinegar', category: 'Oils', unit: 'ml', shelfDays: 730 },
  { name: 'Sherry Vinegar', category: 'Oils', unit: 'ml', shelfDays: 730 },

  // ── Spices ──────────────────────────────────────────
  { name: 'Salt', category: 'Spices', unit: 'grams', shelfDays: 1825 },
  { name: 'Black Pepper', category: 'Spices', unit: 'grams', shelfDays: 730 },
  { name: 'White Pepper', category: 'Spices', unit: 'grams', shelfDays: 730 },
  { name: 'Cayenne Pepper', category: 'Spices', unit: 'grams', shelfDays: 730 },
  { name: 'Red Pepper Flakes', category: 'Spices', unit: 'grams', shelfDays: 730 },
  { name: 'Paprika', category: 'Spices', unit: 'grams', shelfDays: 730 },
  { name: 'Smoked Paprika', category: 'Spices', unit: 'grams', shelfDays: 730 },
  { name: 'Chili Powder', category: 'Spices', unit: 'grams', shelfDays: 730 },
  { name: 'Cumin', category: 'Spices', unit: 'grams', shelfDays: 730 },
  { name: 'Coriander', category: 'Spices', unit: 'grams', shelfDays: 730 },
  { name: 'Turmeric', category: 'Spices', unit: 'grams', shelfDays: 730 },
  { name: 'Cinnamon', category: 'Spices', unit: 'grams', shelfDays: 730 },
  { name: 'Nutmeg', category: 'Spices', unit: 'grams', shelfDays: 730 },
  { name: 'Cloves', category: 'Spices', unit: 'grams', shelfDays: 730 },
  { name: 'Allspice', category: 'Spices', unit: 'grams', shelfDays: 730 },
  { name: 'Cardamom', category: 'Spices', unit: 'grams', shelfDays: 730 },
  { name: 'Garam Masala', category: 'Spices', unit: 'grams', shelfDays: 365 },
  { name: 'Curry Powder', category: 'Spices', unit: 'grams', shelfDays: 365 },
  { name: 'Five Spice', category: 'Spices', unit: 'grams', shelfDays: 365 },
  { name: 'Italian Seasoning', category: 'Spices', unit: 'grams', shelfDays: 365 },
  { name: 'Oregano (dried)', category: 'Spices', unit: 'grams', shelfDays: 730 },
  { name: 'Thyme (dried)', category: 'Spices', unit: 'grams', shelfDays: 730 },
  { name: 'Rosemary (dried)', category: 'Spices', unit: 'grams', shelfDays: 730 },
  { name: 'Basil (dried)', category: 'Spices', unit: 'grams', shelfDays: 730 },
  { name: 'Dill (dried)', category: 'Spices', unit: 'grams', shelfDays: 730 },
  { name: 'Garlic Powder', category: 'Spices', unit: 'grams', shelfDays: 730 },
  { name: 'Onion Powder', category: 'Spices', unit: 'grams', shelfDays: 730 },
  { name: 'Mustard Powder', category: 'Spices', unit: 'grams', shelfDays: 730 },
  { name: 'Bay Leaves (dried)', category: 'Spices', unit: 'grams', shelfDays: 730 },
  { name: 'Saffron', category: 'Spices', unit: 'grams', shelfDays: 730 },
  { name: 'Star Anise', category: 'Spices', unit: 'grams', shelfDays: 730 },
  { name: 'Fennel Seeds', category: 'Spices', unit: 'grams', shelfDays: 730 },
  { name: 'Celery Seed', category: 'Spices', unit: 'grams', shelfDays: 730 },
  { name: 'Mustard Seeds', category: 'Spices', unit: 'grams', shelfDays: 730 },
  { name: 'Vanilla Extract', category: 'Spices', unit: 'ml', shelfDays: 1825 },
  { name: 'Almond Extract', category: 'Spices', unit: 'ml', shelfDays: 1825 },

  // ── Condiments & Sauces ─────────────────────────────
  { name: 'Ketchup', category: 'Condiments', unit: 'ml', shelfDays: 180 },
  { name: 'Mustard', category: 'Condiments', unit: 'ml', shelfDays: 365 },
  { name: 'Dijon Mustard', category: 'Condiments', unit: 'ml', shelfDays: 365 },
  { name: 'Whole Grain Mustard', category: 'Condiments', unit: 'ml', shelfDays: 365 },
  { name: 'Mayonnaise', category: 'Condiments', unit: 'ml', shelfDays: 60 },
  { name: 'Hot Sauce', category: 'Condiments', unit: 'ml', shelfDays: 365 },
  { name: 'Sriracha', category: 'Condiments', unit: 'ml', shelfDays: 365 },
  { name: 'Soy Sauce', category: 'Condiments', unit: 'ml', shelfDays: 730 },
  { name: 'Tamari', category: 'Condiments', unit: 'ml', shelfDays: 730 },
  { name: 'Fish Sauce', category: 'Condiments', unit: 'ml', shelfDays: 730 },
  { name: 'Oyster Sauce', category: 'Condiments', unit: 'ml', shelfDays: 365 },
  { name: 'Hoisin Sauce', category: 'Condiments', unit: 'ml', shelfDays: 365 },
  { name: 'Teriyaki Sauce', category: 'Condiments', unit: 'ml', shelfDays: 365 },
  { name: 'Worcestershire Sauce', category: 'Condiments', unit: 'ml', shelfDays: 730 },
  { name: 'BBQ Sauce', category: 'Condiments', unit: 'ml', shelfDays: 180 },
  { name: 'Marinara Sauce', category: 'Condiments', unit: 'ml', shelfDays: 7 },
  { name: 'Pesto', category: 'Condiments', unit: 'grams', shelfDays: 7 },
  { name: 'Salsa', category: 'Condiments', unit: 'ml', shelfDays: 14 },
  { name: 'Tahini', category: 'Condiments', unit: 'grams', shelfDays: 180 },
  { name: 'Hummus', category: 'Condiments', unit: 'grams', shelfDays: 7 },
  { name: 'Miso Paste', category: 'Condiments', unit: 'grams', shelfDays: 365 },
  { name: 'Tomato Paste', category: 'Condiments', unit: 'grams', shelfDays: 7 },
  { name: 'Harissa', category: 'Condiments', unit: 'grams', shelfDays: 30 },
  { name: 'Chili Garlic Sauce', category: 'Condiments', unit: 'ml', shelfDays: 365 },
  { name: 'Gochujang', category: 'Condiments', unit: 'grams', shelfDays: 365 },
  { name: 'Sambal Oelek', category: 'Condiments', unit: 'grams', shelfDays: 365 },
  { name: 'Relish', category: 'Condiments', unit: 'ml', shelfDays: 180 },
  { name: 'Capers', category: 'Condiments', unit: 'grams', shelfDays: 365 },
  { name: 'Olives', category: 'Condiments', unit: 'grams', shelfDays: 30 },

  // ── Canned & Jarred ─────────────────────────────────
  { name: 'Canned Tomatoes', category: 'Canned', unit: 'grams', shelfDays: 730 },
  { name: 'Crushed Tomatoes', category: 'Canned', unit: 'grams', shelfDays: 730 },
  { name: 'San Marzano Tomatoes', category: 'Canned', unit: 'grams', shelfDays: 730 },
  { name: 'Tomato Sauce', category: 'Canned', unit: 'ml', shelfDays: 730 },
  { name: 'Canned Corn', category: 'Canned', unit: 'grams', shelfDays: 730 },
  { name: 'Canned Green Beans', category: 'Canned', unit: 'grams', shelfDays: 730 },
  { name: 'Canned Coconut Milk', category: 'Canned', unit: 'ml', shelfDays: 730 },
  { name: 'Coconut Cream', category: 'Canned', unit: 'ml', shelfDays: 730 },
  { name: 'Artichoke Hearts', category: 'Canned', unit: 'grams', shelfDays: 730 },
  { name: 'Roasted Red Peppers', category: 'Canned', unit: 'grams', shelfDays: 730 },
  { name: 'Sun-Dried Tomatoes', category: 'Canned', unit: 'grams', shelfDays: 365 },
  { name: 'Chipotles in Adobo', category: 'Canned', unit: 'grams', shelfDays: 730 },
  { name: 'Broth (chicken)', category: 'Canned', unit: 'ml', shelfDays: 730 },
  { name: 'Broth (beef)', category: 'Canned', unit: 'ml', shelfDays: 730 },
  { name: 'Broth (vegetable)', category: 'Canned', unit: 'ml', shelfDays: 730 },
  { name: 'Bone Broth', category: 'Canned', unit: 'ml', shelfDays: 14 },

  // ── Baking ──────────────────────────────────────────
  { name: 'All-Purpose Flour', category: 'Baking', unit: 'grams', shelfDays: 365 },
  { name: 'Bread Flour', category: 'Baking', unit: 'grams', shelfDays: 365 },
  { name: 'Cake Flour', category: 'Baking', unit: 'grams', shelfDays: 365 },
  { name: 'Whole Wheat Flour', category: 'Baking', unit: 'grams', shelfDays: 180 },
  { name: 'Almond Flour', category: 'Baking', unit: 'grams', shelfDays: 180 },
  { name: 'Coconut Flour', category: 'Baking', unit: 'grams', shelfDays: 365 },
  { name: 'Cornmeal', category: 'Baking', unit: 'grams', shelfDays: 365 },
  { name: 'Cornstarch', category: 'Baking', unit: 'grams', shelfDays: 730 },
  { name: 'Tapioca Starch', category: 'Baking', unit: 'grams', shelfDays: 730 },
  { name: 'Granulated Sugar', category: 'Baking', unit: 'grams', shelfDays: 730 },
  { name: 'Brown Sugar', category: 'Baking', unit: 'grams', shelfDays: 365 },
  { name: 'Powdered Sugar', category: 'Baking', unit: 'grams', shelfDays: 730 },
  { name: 'Honey', category: 'Baking', unit: 'ml', shelfDays: 730 },
  { name: 'Maple Syrup', category: 'Baking', unit: 'ml', shelfDays: 365 },
  { name: 'Agave Nectar', category: 'Baking', unit: 'ml', shelfDays: 365 },
  { name: 'Molasses', category: 'Baking', unit: 'ml', shelfDays: 365 },
  { name: 'Corn Syrup', category: 'Baking', unit: 'ml', shelfDays: 365 },
  { name: 'Baking Powder', category: 'Baking', unit: 'grams', shelfDays: 365 },
  { name: 'Baking Soda', category: 'Baking', unit: 'grams', shelfDays: 730 },
  { name: 'Active Dry Yeast', category: 'Baking', unit: 'grams', shelfDays: 120 },
  { name: 'Instant Yeast', category: 'Baking', unit: 'grams', shelfDays: 120 },
  { name: 'Cocoa Powder', category: 'Baking', unit: 'grams', shelfDays: 730 },
  { name: 'Dark Chocolate', category: 'Baking', unit: 'grams', shelfDays: 365 },
  { name: 'Chocolate Chips', category: 'Baking', unit: 'grams', shelfDays: 365 },
  { name: 'Gelatin', category: 'Baking', unit: 'grams', shelfDays: 730 },
  { name: 'Cream of Tartar', category: 'Baking', unit: 'grams', shelfDays: 730 },
  { name: 'Food Coloring', category: 'Baking', unit: 'ml', shelfDays: 730 },

  // ── Frozen ──────────────────────────────────────────
  { name: 'Frozen Peas', category: 'Frozen', unit: 'grams', shelfDays: 365 },
  { name: 'Frozen Corn', category: 'Frozen', unit: 'grams', shelfDays: 365 },
  { name: 'Frozen Spinach', category: 'Frozen', unit: 'grams', shelfDays: 365 },
  { name: 'Frozen Broccoli', category: 'Frozen', unit: 'grams', shelfDays: 365 },
  { name: 'Frozen Mixed Vegetables', category: 'Frozen', unit: 'grams', shelfDays: 365 },
  { name: 'Frozen Berries', category: 'Frozen', unit: 'grams', shelfDays: 365 },
  { name: 'Frozen Strawberries', category: 'Frozen', unit: 'grams', shelfDays: 365 },
  { name: 'Frozen Mango', category: 'Frozen', unit: 'grams', shelfDays: 365 },
  { name: 'Frozen Shrimp', category: 'Frozen', unit: 'grams', shelfDays: 180 },
  { name: 'Frozen Fish Fillets', category: 'Frozen', unit: 'grams', shelfDays: 180 },
  { name: 'Frozen Pizza Dough', category: 'Frozen', unit: 'grams', shelfDays: 90 },
  { name: 'Frozen Pie Crust', category: 'Frozen', unit: 'grams', shelfDays: 90 },
  { name: 'Frozen Puff Pastry', category: 'Frozen', unit: 'grams', shelfDays: 90 },
  { name: 'Ice Cream', category: 'Frozen', unit: 'ml', shelfDays: 60 },

  // ── Beverages & Misc ────────────────────────────────
  { name: 'Coffee (ground)', category: 'Beverages', unit: 'grams', shelfDays: 90 },
  { name: 'Coffee (whole bean)', category: 'Beverages', unit: 'grams', shelfDays: 180 },
  { name: 'Espresso', category: 'Beverages', unit: 'grams', shelfDays: 90 },
  { name: 'Green Tea', category: 'Beverages', unit: 'grams', shelfDays: 365 },
  { name: 'Black Tea', category: 'Beverages', unit: 'grams', shelfDays: 365 },
  { name: 'Chamomile Tea', category: 'Beverages', unit: 'grams', shelfDays: 365 },
  { name: 'Matcha Powder', category: 'Beverages', unit: 'grams', shelfDays: 180 },
  { name: 'Orange Juice', category: 'Beverages', unit: 'ml', shelfDays: 7 },
  { name: 'Lemon Juice', category: 'Beverages', unit: 'ml', shelfDays: 30 },
  { name: 'Lime Juice', category: 'Beverages', unit: 'ml', shelfDays: 30 },
  { name: 'Cranberry Juice', category: 'Beverages', unit: 'ml', shelfDays: 14 },
  { name: 'Almond Milk', category: 'Beverages', unit: 'ml', shelfDays: 7 },
  { name: 'Oat Milk', category: 'Beverages', unit: 'ml', shelfDays: 7 },
  { name: 'Coconut Milk (carton)', category: 'Beverages', unit: 'ml', shelfDays: 7 },
  { name: 'Soy Milk', category: 'Beverages', unit: 'ml', shelfDays: 7 },

  // ── Nut Butters & Spreads ───────────────────────────
  { name: 'Peanut Butter', category: 'Spreads', unit: 'grams', shelfDays: 180 },
  { name: 'Almond Butter', category: 'Spreads', unit: 'grams', shelfDays: 180 },
  { name: 'Cashew Butter', category: 'Spreads', unit: 'grams', shelfDays: 180 },
  { name: 'Sunflower Seed Butter', category: 'Spreads', unit: 'grams', shelfDays: 180 },
  { name: 'Nutella', category: 'Spreads', unit: 'grams', shelfDays: 365 },
  { name: 'Jam', category: 'Spreads', unit: 'grams', shelfDays: 365 },
  { name: 'Marmalade', category: 'Spreads', unit: 'grams', shelfDays: 365 },

  // ── Dried Fruits ────────────────────────────────────
  { name: 'Raisins', category: 'Dried Fruits', unit: 'grams', shelfDays: 365 },
  { name: 'Dried Cranberries', category: 'Dried Fruits', unit: 'grams', shelfDays: 365 },
  { name: 'Dried Apricots', category: 'Dried Fruits', unit: 'grams', shelfDays: 180 },
  { name: 'Dried Figs', category: 'Dried Fruits', unit: 'grams', shelfDays: 180 },
  { name: 'Dried Mango', category: 'Dried Fruits', unit: 'grams', shelfDays: 180 },
  { name: 'Prunes', category: 'Dried Fruits', unit: 'grams', shelfDays: 365 },
  { name: 'Dried Coconut', category: 'Dried Fruits', unit: 'grams', shelfDays: 365 },
  { name: 'Goji Berries', category: 'Dried Fruits', unit: 'grams', shelfDays: 365 },

  // ── Protein & Supplements ───────────────────────────
  { name: 'Whey Protein Powder', category: 'Supplements', unit: 'grams', shelfDays: 365 },
  { name: 'Casein Protein Powder', category: 'Supplements', unit: 'grams', shelfDays: 365 },
  { name: 'Plant Protein Powder', category: 'Supplements', unit: 'grams', shelfDays: 365 },
  { name: 'Collagen Peptides', category: 'Supplements', unit: 'grams', shelfDays: 365 },
  { name: 'Creatine', category: 'Supplements', unit: 'grams', shelfDays: 730 },
  { name: 'Nutritional Yeast', category: 'Supplements', unit: 'grams', shelfDays: 365 },
  { name: 'Spirulina', category: 'Supplements', unit: 'grams', shelfDays: 365 },

  // ── International & Specialty ───────────────────────
  { name: 'Kimchi', category: 'International', unit: 'grams', shelfDays: 30 },
  { name: 'Sauerkraut', category: 'International', unit: 'grams', shelfDays: 30 },
  { name: 'Nori Sheets', category: 'International', unit: 'grams', shelfDays: 365 },
  { name: 'Wakame', category: 'International', unit: 'grams', shelfDays: 365 },
  { name: 'Kombu', category: 'International', unit: 'grams', shelfDays: 365 },
  { name: 'Rice Paper', category: 'International', unit: 'grams', shelfDays: 730 },
  { name: 'Wonton Wrappers', category: 'International', unit: 'grams', shelfDays: 7 },
  { name: 'Dumpling Wrappers', category: 'International', unit: 'grams', shelfDays: 7 },
  { name: 'Paneer', category: 'International', unit: 'grams', shelfDays: 7 },
  { name: 'Ghee', category: 'International', unit: 'grams', shelfDays: 90 },
  { name: 'Curry Paste (red)', category: 'International', unit: 'grams', shelfDays: 90 },
  { name: 'Curry Paste (green)', category: 'International', unit: 'grams', shelfDays: 90 },
  { name: 'Curry Paste (yellow)', category: 'International', unit: 'grams', shelfDays: 90 },
  { name: 'Tamarind Paste', category: 'International', unit: 'grams', shelfDays: 365 },
  { name: 'Mirin', category: 'International', unit: 'ml', shelfDays: 365 },
  { name: 'Sake (cooking)', category: 'International', unit: 'ml', shelfDays: 365 },
  { name: 'Shaoxing Wine', category: 'International', unit: 'ml', shelfDays: 365 },
  { name: 'Dashi Powder', category: 'International', unit: 'grams', shelfDays: 365 },
  { name: 'Bonito Flakes', category: 'International', unit: 'grams', shelfDays: 365 },
  { name: 'Tortilla Chips', category: 'International', unit: 'grams', shelfDays: 60 },
  { name: 'Taco Shells', category: 'International', unit: 'grams', shelfDays: 60 },
  { name: 'Enchilada Sauce', category: 'International', unit: 'ml', shelfDays: 365 },
  { name: 'Adobo Seasoning', category: 'International', unit: 'grams', shelfDays: 365 },
  { name: 'Harissa Paste', category: 'International', unit: 'grams', shelfDays: 90 },
  { name: 'Za\'atar', category: 'International', unit: 'grams', shelfDays: 365 },
  { name: 'Sumac', category: 'International', unit: 'grams', shelfDays: 365 },
  { name: 'Pomegranate Molasses', category: 'International', unit: 'ml', shelfDays: 365 },
  { name: 'Rose Water', category: 'International', unit: 'ml', shelfDays: 365 },
  { name: 'Preserved Lemons', category: 'International', unit: 'grams', shelfDays: 365 },
];

export default KITCHEN_ITEMS;
